import React, { memo, ReactElement } from "react";

function ChevronRightIcon(props: {
    className?: string;
    strokeColor?: string;
    strokeOpacity?: number;
    strokeWidth?: number;
}): ReactElement {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <path
                d="M8 14L12 10L8 6"
                stroke={props.strokeColor || "#02060C"}
                strokeOpacity={props.strokeOpacity || "0.45"}
                strokeWidth={props.strokeWidth || "1.5"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default memo(ChevronRightIcon);
